module.exports = __webpack_public_path__ + "img/internet.ff5256ca.svg";